import { DocumentFilter } from '../../../../types';
import { buildHeadersFromDocumentParams } from '../../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { FILTERS_BASE_PATH } from '../constants/filtersBasePath';

export const getFilters = async (
  constructGet: ConstructGet,
  params?: DocumentParams,
): Promise<NonPaginatedResponse<DocumentFilter[]> | undefined> =>
  constructGet<NonPaginatedResponse<DocumentFilter[]>>(FILTERS_BASE_PATH, {
    headers: params ? buildHeadersFromDocumentParams(params) : undefined,
  });
